// extracted by mini-css-extract-plugin
export default {"author_image":"Article_author_image__VgAAX","hero_image":"Article_hero_image__yFs+E","link_underline":"Article_link_underline__gur-t"};